<template>
  <div style="height: 100%">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1920 1440"
      style="enable-background: new 0 0 1920 1440"
      xml:space="preserve"
    >
      <g id="Background_xA0_Image_1_">
        <image
          style="overflow: visible"
          width="1920"
          height="1440"
          id="Background_xA0_Image"
          :xlink:href="main_lobby_img"
        ></image>
      </g>
      <g id="Clickable_Vendor_Logo_links_1_" class="st0">
        <g id="Vendor_Logo_link_1_xA0_Image_1_" :class="(object_list.SPONSER_1_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_1_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_1_xA0_Image"
            :xlink:href="object_list.SPONSER_1"
            transform="matrix(1 0 0 1 550 319)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_2_xA0_Image_1_" :class="(object_list.SPONSER_2_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_2_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_2_xA0_Image"
            :xlink:href="object_list.SPONSER_2"
            transform="matrix(1 0 0 1 550 364)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_3_xA0_Image_1_" :class="(object_list.SPONSER_3_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_3_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_3_xA0_Image"
            :xlink:href="object_list.SPONSER_3"
            transform="matrix(1 0 0 1 550 409)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_4_xA0_Image_1_" :class="(object_list.SPONSER_4_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_4_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_4_xA0_Image"
            :xlink:href="object_list.SPONSER_4"
            transform="matrix(1 0 0 1 550 454)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_5_xA0_Image_1_" :class="(object_list.SPONSER_5_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_5_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_5_xA0_Image"
            :xlink:href="object_list.SPONSER_5"
            transform="matrix(1 0 0 1 710 319)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_6_xA0_Image_1_" :class="(object_list.SPONSER_6_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_6_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_6_xA0_Image"
            :xlink:href="object_list.SPONSER_6"
            transform="matrix(1 0 0 1 710 364)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_7_xA0_Image_1_" :class="(object_list.SPONSER_7_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_7_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_7_xA0_Image"
            :xlink:href="object_list.SPONSER_7"
            transform="matrix(1 0 0 1 710 409)"
          ></image>
        </g>
        <g id="Vendor_Logo_link_8_xA0_Image_1_" :class="(object_list.SPONSER_8_LINK)?'cursor_pointer':''" @click="$helper.openUrl(object_list.SPONSER_8_LINK)">
          <image
            style="overflow: visible"
            width="160"
            height="45"
            id="Vendor_Logo_link_8_xA0_Image"
            :xlink:href="object_list.SPONSER_8"
            transform="matrix(1 0 0 1 710 454)"
          ></image>
        </g>
      </g>
      <g id="Area_reserved_for_Video_xA0_Image_1_" class="st0 cursor_pointer">
        <image
          style="overflow: visible"
          width="320"
          height="180"
          id="Area_reserved_for_Video_xA0_Image"
          :xlink:href="intro_video_thumb"
          @click="ShowVideo(object_list.INTRODUCTION_VIDEO)"
          transform="matrix(1 0 0 1 1050 319)"
        ></image>
      </g>
      <g id="Rectangle_3_2_" class="st1 cursor_pointer" @click="openPage('vendor-hall')">
        <defs>
          <rect
            id="SVGID_1_"
            x="609"
            y="542"
            class="st1"
            width="702"
            height="156"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>

        <image
          style="overflow: visible; clip-path: url(#SVGID_2_)"
          width="1920"
          height="1440"
          id="Rectangle_3_xA0_Image"
          :xlink:href="layer_image"
        ></image>
      </g>
      <g id="Rectangle_2_2_" class="st1 cursor_pointer" @click="openPage('session')">
        <defs>
          <rect
            id="SVGID_3_"
            x="721"
            y="720"
            class="st1"
            width="478"
            height="86"
          />
        </defs>
        <clipPath id="SVGID_4_">
          <use xlink:href="#SVGID_3_" style="overflow: visible" />
        </clipPath>

        <image
          style="overflow: visible; clip-path: url(#SVGID_4_)"
          width="1920"
          height="1440"
          id="Rectangle_2_xA0_Image"
          :xlink:href="layer_image"
        ></image>
      </g>
      <g id="Rectangle_1_2_" class="st1 cursor_pointer" @click="openPage('info-desk')">
        <defs>
          <rect id="SVGID_5_" y="768" class="st1" width="512" height="256" />
        </defs>
        <clipPath id="SVGID_6_">
          <use xlink:href="#SVGID_5_" style="overflow: visible" />
        </clipPath>

        <image
          style="overflow: visible; clip-path: url(#SVGID_6_)"
          width="1920"
          height="1440"
          id="Rectangle_1_xA0_Image"
          :xlink:href="layer_image"
        ></image>
      </g>
    </svg>
    <v-dialog v-model="show_preview" max-width="50%">
      <v-card>
        <v-card-text class="pt-2 rounded-lg px-0 py-0">
          <video :src="preview_data" width="100%" autoplay v-if="preview_data" controls></video>
        </v-card-text>
        <v-btn style="position:absolute;top:0px;right:10px" color="red" dark fab small @click="show_preview = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" text @click="show_preview = false"
            >Close</v-btn
          >
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/helper/axios";
export default {
  name: "MainImage",
  data() {
    return {
      loading: false,
      preview_data: null,
      show_preview: false,
      object_list: {
        SPONSER_1: "",
        SPONSER_1_LINK: "",
      },
    };
  },
  methods: {
    getObjects() {
      let _self = this;
      axios
        .get("object/get?page_name=MAIN_LOBBY")
        .then(function (response) {

          // _self.object_list = response.data.data
          for (let key in response.data.data) {
            let data = response.data.data[key];
            // let field_name = data.page_position[0].value;
            // let value_of_field = data.upload_url;
            _self.object_list[data.page_position[0].value] = data.upload_url;
            _self.object_list[data.page_position[0].value+'_LINK'] = data.link;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
      console.log(_self.object_list);
    },
    ShowVideo(video_src) {
      this.show_preview = true;
      this.preview_data = video_src;
    },
    openPage(route) {
      this.$router.push(route);
    },
  },
  watch : {
    show_preview : function(value){
      if(!value){
       this.preview_data = null
      }
    }
  },
  computed: {
    main_lobby_img() {
      return process.env.VUE_APP_ASSETS + "main_lobby.jpg";
    },
    intro_video_thumb() {
      return process.env.VUE_APP_ASSETS + "intro_video_thumb.png";
    },
    layer_image() {
      return process.env.VUE_APP_ASSETS + "layer_img.png";
    },
  },
  created() {
    this.loading = true;
    this.getObjects();
  },
};
</script>
<style type="text/css">
.st0 {
  opacity: 1 !important;
}
.st1 {
  enable-background: new;
}
</style>